// extracted by mini-css-extract-plugin
module.exports = {"deliveryDropPointMap":"DeliveryDropPointMap_deliveryDropPointMap__VxUM_","list":"DeliveryDropPointMap_list__vR_Zk","map":"DeliveryDropPointMap_map__BzjuI"};